module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"EssentialDesc":"Basic Package for Data Integrations","Essential":"Essential","Pro":"Pro","Enterprise":"Enterprise","ProDesc":"Basic Package for Store Analysis and IoT Integrations","EnterpriseDesc":"Basic Package for Store Analyais including IoT Integrations, High Security Option","contact":"Contact Now","StorePerMonth":"Store Per Month"}}')
  delete Component.options._Ctor
}
